import axios from 'axios'
import '@/api'
import { extract } from './utils'
import { merge } from 'lodash'

// ------------------------------------
// Endpoint Configuration
// ------------------------------------

const endpointConfig = {
  url: '/itemFilterGroups'
}

// ------------------------------------
// Initial State
// ------------------------------------

const state = {
  itemFilterGroup: {},
  itemFilterGroups: []
}

// ------------------------------------
// Getters
// ------------------------------------

const getters = {
  itemFilterGroup: state => state.itemFilterGroup,
  itemFilterGroups: state => state.itemFilterGroups
}

// ------------------------------------
// Constants
// ------------------------------------

const REQUEST_GET_ITEM_FILTER_GROUP = 'REQUEST_GET_ITEM_FILTER_GROUP'
const RECEIVE_GET_ITEM_FILTER_GROUP = 'RECEIVE_GET_ITEM_FILTER_GROUP'

const REQUEST_CREATE_ITEM_FILTER_GROUP = 'REQUEST_CREATE_ITEM_FILTER_GROUP'
const RECEIVE_CREATE_ITEM_FILTER_GROUP = 'RECEIVE_CREATE_ITEM_FILTER_GROUP'

const REQUEST_UPDATE_ITEM_FILTER_GROUP = 'REQUEST_UPDATE_ITEM_FILTER_GROUP'
const RECEIVE_UPDATE_ITEM_FILTER_GROUP = 'RECEIVE_UPDATE_ITEM_FILTER_GROUP'

const REQUEST_DELETE_ITEM_FILTER_GROUP = 'REQUEST_DELETE_ITEM_FILTER_GROUP'
const RECEIVE_DELETE_ITEM_FILTER_GROUP = 'RECEIVE_DELETE_ITEM_FILTER_GROUP'

const UPDATE_ITEM_FILTER_GROUP_PROPERTY = 'UPDATE_ITEM_FILTER_GROUP_PROPERTY'

const REQUEST_GET_ITEM_FILTER_GROUPS = 'REQUEST_GET_ITEM_FILTER_GROUPS'
const RECEIVE_GET_ITEM_FILTER_GROUPS = 'RECEIVE_GET_ITEM_FILTER_GROUPS'

// ------------------------------------
// Actions
// ------------------------------------

const actions = {
  async getItemFilterGroups ({ commit, dispatch }, { includes = undefined, filters = undefined, sort = undefined }) {
    dispatch('wait/start', 'getting itemFilterGroups', { root: true })
    commit(REQUEST_GET_ITEM_FILTER_GROUPS)
    const config = merge({}, endpointConfig, { params: merge({}, filters, { include: includes }, { sort: sort }) })
    return axios.get(endpointConfig.url, config)
      .then((response) => {
        dispatch('receiveItemFilterGroups', [ response.data, 'GET' ])
        dispatch('wait/end', 'getting itemFilterGroups', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'getting itemFilterGroups', { root: true })
        return Promise.reject(error)
      })
  },
  async getItemFilterGroup ({ commit, dispatch }, { id, includes = undefined }) {
    dispatch('wait/start', 'getting itemFilterGroup', { root: true })
    commit(REQUEST_GET_ITEM_FILTER_GROUP, id)
    const config = merge({}, endpointConfig, { params: { include: includes } })
    return axios.get(`${endpointConfig.url}/${id}`, config)
      .then((response) => {
        dispatch('receiveItemFilterGroup', [ response.data, 'GET' ])
        dispatch('wait/end', 'getting itemFilterGroup', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'getting itemFilterGroup', { root: true })
        return Promise.reject(error)
      })
  },
  async createItemFilterGroup ({ commit, dispatch }, data) {
    dispatch('wait/start', 'creating itemFilterGroup', { root: true })
    commit(REQUEST_CREATE_ITEM_FILTER_GROUP, data)
    return axios.post(`${endpointConfig.url}`, data, endpointConfig)
      .then((response) => {
        dispatch('receiveItemFilterGroup', [ response.data, 'CREATE' ])
        dispatch('wait/end', 'creating itemFilterGroup', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'creating itemFilterGroup', { root: true })
        return Promise.reject(error)
      })
  },
  async updateItemFilterGroup ({ commit, dispatch }, [ id, data ]) {
    dispatch('wait/start', 'updating itemFilterGroup', { root: true })
    commit(REQUEST_UPDATE_ITEM_FILTER_GROUP, id)
    return axios.put(`${endpointConfig.url}/${id}`, data, endpointConfig)
      .then((response) => {
        dispatch('receiveItemFilterGroup', [ response.data, 'UPDATE' ])
        dispatch('wait/end', 'updating itemFilterGroup', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'updating itemFilterGroup', { root: true })
        return Promise.reject(error)
      })
  },
  async deleteItemFilterGroup ({ commit, dispatch }, id) {
    dispatch('wait/start', 'deleting itemFilterGroup', { root: true })
    commit(REQUEST_DELETE_ITEM_FILTER_GROUP, id)
    return axios.delete(`${endpointConfig.url}/${id}`, endpointConfig)
      .then((response) => {
        commit(RECEIVE_DELETE_ITEM_FILTER_GROUP, response.data)
        dispatch('wait/end', 'deleting itemFilterGroup', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'deleting itemFilterGroup', { root: true })
        return Promise.reject(error)
      })
  },
  receiveItemFilterGroup ({ commit, dispatch }, [ json, action ]) {
    commit(`RECEIVE_${action}_ITEM_FILTER_GROUP`, extract(json))
    return json.data
  },
  receiveItemFilterGroups ({ commit, dispatch }, [ json, action ]) {
    commit(`RECEIVE_${action}_ITEM_FILTER_GROUPS`, extract(json))
    return json.data
  },
  updateItemFilterGroupProperty ({ commit, dispatch }, [ property, value ]) {
    commit(`UPDATE_ITEM_FILTER_GROUP_PROPERTY`, [ property, value ])
  }
}

// ------------------------------------
// Mutations
// ------------------------------------

const mutations = {
  [REQUEST_GET_ITEM_FILTER_GROUP] (state, id) {
  },
  [RECEIVE_GET_ITEM_FILTER_GROUP] (state, json) {
    state.itemFilterGroup = json
  },
  [REQUEST_CREATE_ITEM_FILTER_GROUP] (state, json) {
  },
  [RECEIVE_CREATE_ITEM_FILTER_GROUP] (state, json) {
    state.itemFilterGroup = json
  },
  [REQUEST_UPDATE_ITEM_FILTER_GROUP] (state, id) {
  },
  [RECEIVE_UPDATE_ITEM_FILTER_GROUP] (state, json) {
    state.itemFilterGroup = json
  },
  [REQUEST_DELETE_ITEM_FILTER_GROUP] (state, id) {
  },
  [RECEIVE_DELETE_ITEM_FILTER_GROUP] (state, json) {
    state.itemFilterGroup = {}
  },
  [UPDATE_ITEM_FILTER_GROUP_PROPERTY] (state, [ property, value ]) {
    state.itemFilterGroup[property] = value
  },
  [REQUEST_GET_ITEM_FILTER_GROUPS] (state) {
  },
  [RECEIVE_GET_ITEM_FILTER_GROUPS] (state, json) {
    state.itemFilterGroups = json
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
